declare global {
    interface Window {
        /** Console switch. `true` allows picking a visible sheet in the scene. */
        __NOVO_SHEET_SCENE_SELECTION__?: boolean;
    }
}

/** Shared by this frame and the host page so either console reads the same switch. */
let allowSheetSceneSelection = false;

function publishSheetSceneSelectionFlag(target: Window): void {
    const existing = Object.getOwnPropertyDescriptor(target, "__NOVO_SHEET_SCENE_SELECTION__");
    if (existing?.get) {
        return;
    }
    Object.defineProperty(target, "__NOVO_SHEET_SCENE_SELECTION__", {
        configurable: true,
        enumerable: true,
        get: () => allowSheetSceneSelection,
        set: (value: boolean) => {
            allowSheetSceneSelection = value === true;
        },
    });
}

function installSheetSceneSelectionFlag(): void {
    if (typeof window === "undefined") {
        return;
    }
    publishSheetSceneSelectionFlag(window);
    try {
        if (window.top && window.top !== window) {
            publishSheetSceneSelectionFlag(window.top);
        }
    } catch {
        // The host page is cross-origin; the switch stays on this frame.
    }
}

installSheetSceneSelectionFlag();

export function isSheetSceneSelectionAllowed(): boolean {
    return allowSheetSceneSelection;
}

/** A hidden sheet is not pickable, so the flag only has to block visible sheets. */
export function sheetScenePickIsBlocked(isSheet: boolean): boolean {
    return isSheet && !isSheetSceneSelectionAllowed();
}

/** Sheet ids are omitted. They are added to the scene after the model geometry. */
export function countModelGeometryIds(
    ids: ArrayLike<number>,
    pdfObjectIds: { has(id: number): boolean; size: number } | undefined,
): number {
    if (!pdfObjectIds || pdfObjectIds.size === 0) {
        return ids.length;
    }
    let count = 0;
    for (let index = 0; index < ids.length; index++) {
        if (!pdfObjectIds.has(ids[index])) {
            count += 1;
        }
    }
    return count;
}
